import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import UserAvatar from '@wix/da-shared-react/pkg/User/Avatar/UserAvatar';
import UserLink from '@wix/da-shared-react/pkg/User/Link/UserLink';
import TopCustomerIcon, {
  Props as TopCustomerIconProps,
} from '@wix/da-ds/pkg/Icons/32x32/TopCustomer';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { DATE_FORMATS, formatDate } from '@wix/da-i18next/pkg/time/functions';
import { PapiDataPackageSellerTopCustomers } from '@wix/da-papi-types';

import s from './TopCustomersTableRowHeadingMobile.scss';

interface Props {
  item: NonNullable<PapiDataPackageSellerTopCustomers['timePeriods']['ALL']>[number];
  index: number;
}

const TopCustomersTableRowHeadingMobile: FC<Props> = ({ item, index }) => {
  const { t, i18n } = useTranslation();

  const { user, lastPurchaseDate } = item;

  if (!user) {
    return null;
  }

  // The first three rows have an icon overlaid on the avatar
  let overlayIcon;
  if (index >= 0 && index < 3) {
    overlayIcon = (
      <TopCustomerIcon
        position={(index + 1) as TopCustomerIconProps['position']}
        size={IconSize.LARGE}
      />
    );
  }

  return (
    <Flex direction="row" gap={8}>
      <UserAvatar user={user} size={40} overlayIcon={overlayIcon} />
      <Flex direction="column">
        <UserLink user={user} className={s['username']} />
        <div className={s['timestamp']}>
          {t('studio.reports.section.topCustomers.table.header.lastPurchase')}:{' '}
          {lastPurchaseDate && formatDate(lastPurchaseDate, DATE_FORMATS.Date.Full, i18n.language)}
        </div>
      </Flex>
    </Flex>
  );
};
TopCustomersTableRowHeadingMobile.displayName = 'TopCustomersTableRowHeadingMobile';

export default TopCustomersTableRowHeadingMobile;
